import * as React from "react";
import { Container } from "reactstrap";

export default function Footer() {
  return (
    <footer className="bg-navy-dark">
      <Container fluid>
        <div className="text-center text-white-50 p-4">
          © {new Date().getFullYear()}{" "}
          <a className="text-warning fw-bold" href="https://www.fencebuildr.com/">
            Fencebuildr.com
          </a>
        </div>
      </Container>
    </footer>
  );
}
